import Swiper from "swiper";
import { Autoplay, EffectFade, Pagination, Navigation } from "swiper/modules";

new Swiper(".mvSwiper", {
    speed: 1,
    modules: [Autoplay, EffectFade],
    autoplay: {
        delay: 4000,
        waitForTransition: false,
        disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },
});

const calOn = (swiper) => {
    const yearEls = swiper.el.querySelectorAll(`.swiper-pagination p.year`);
    yearEls.forEach((yearEl) => {
        yearEl.classList.remove("is-crnt");
    });
    yearEls[swiper.realIndex].classList.add("is-crnt");
};

new Swiper(".calSwiper", {
    speed: 600,
    modules: [EffectFade, Navigation],
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    on: {
        init: (swiper) => {
            const yearEls = swiper.el.querySelectorAll(
                `.swiper-pagination p.year`
            );
            yearEls.forEach((yearEl, index) => {
                yearEl.addEventListener("click", () => {
                    swiper.slideTo(index);
                });

                if (yearEl.dataset.sf) {
                    swiper.slideTo(index);
                }
            });
            calOn(swiper);
        },
        slideChange: calOn,
    },
});

let recrutiSwiper = null;
let recrutiSwiperOpt = {
    slidesPerView: "auto",
    modules: [Autoplay, Pagination],
    autoplay: {
        delay: 4000,
        waitForTransition: false,
        disableOnInteraction: false,
        reverseDirection: true,
    },
    speed: 600,
    loop: true,
    centeredSlides: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
};

// Swiperの初期化関数
const initSwiper = () => {
    const swiperElement = document.querySelector(".RecrutiSwiper");
    if (swiperElement) {
        const isSPOnly = swiperElement.classList.contains("sponly");

        // sponlyクラスがある場合は画面幅で制御
        if (isSPOnly) {
            if (!recrutiSwiper && window.innerWidth <= 1024) {
                recrutiSwiper = new Swiper(".RecrutiSwiper", recrutiSwiperOpt);
            }
        }
        // sponlyクラスがない場合は普通に初期化
        else {
            if (!recrutiSwiper) {
                recrutiSwiper = new Swiper(".RecrutiSwiper", recrutiSwiperOpt);
            }
        }
    }
};

// Swiperの破棄関数
const destroySwiper = () => {
    const swiperElement = document.querySelector(".RecrutiSwiper");
    const isSPOnly = swiperElement.classList.contains("sponly");

    // sponlyクラスがある場合のみ、PCサイズで破棄
    if (isSPOnly && recrutiSwiper && window.innerWidth > 1024) {
        recrutiSwiper.destroy();
        recrutiSwiper = null;
    }
};

// 初期化時に実行
initSwiper();

// リサイズイベントのリスナー（sponlyクラスがある場合のみ動作）
window.addEventListener("resize", () => {
    debounce(() => {
        const swiperElement = document.querySelector(".RecrutiSwiper");
        const isSPOnly = swiperElement.classList.contains("sponly");

        if (isSPOnly) {
            if (window.innerWidth <= 1024) {
                initSwiper();
            } else {
                destroySwiper();
            }
        }
    }, 200);
});

// debounce関数
const debounce = (func, wait) => {
    let timeout;
    return () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(), wait);
    };
};
